import React from 'react'
import PropTypes from 'prop-types'

// TODO SVG this

const PlusSvgIcon = ({ size }) => (
  <span style={{ width: size, height: size, lineHeight: size }}>+</span>
)

PlusSvgIcon.propTypes = {
  size: PropTypes.string,
}
PlusSvgIcon.defaultProps = {
  size: '8px',
}

export default PlusSvgIcon
